import { createContext, useContext, useState } from "react";

const HeaderContext = createContext(null);

export const HeaderProvider = ({ children }) => {
  const [headerExtras, setHeaderExtras] = useState(null);
  return (
    <HeaderContext.Provider value={{ headerExtras, setHeaderExtras }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => useContext(HeaderContext);
